import { render, staticRenderFns } from "./dashboardBudget.vue?vue&type=template&id=f6c1b9e8&scoped=true&"
import script from "./dashboardBudget.vue?vue&type=script&lang=js&"
export * from "./dashboardBudget.vue?vue&type=script&lang=js&"
import style0 from "./dashboardBudget.vue?vue&type=style&index=0&id=f6c1b9e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c1b9e8",
  null
  
)

export default component.exports